import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

interface SitemapSection {
  title: string;
  links: {
    text: string;
    url: string;
    isExternal?: boolean;
    type?: 'link' | 'pdf';
  }[];
}

@Component({
  selector: 'app-informaciones-grid',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './informaciones-grid.component.html',
  styleUrls: ['./informaciones-grid.component.scss']
})
export class InformacionesGridComponent {
  sections: SitemapSection[] = [
    {
      title: 'Información Empresa',
      links: [
        { text: 'Directorio y Administración', url: '/directorio-administracion' },
        { text: 'Estatutos', url: '/estatutos' },
      ]
    },
    {
      title: 'Información Financiera',
      links: [
        { text: 'Estados Financieros', url: '/estados-financieros' },
        { text: 'Memorias', url: '/memorias' },
        { text: 'Reporte de Operacionales Relacionadas', url: '/rop' },
        { text: 'Hechos Esenciales', url: 'https://www.unipay.cl/api/descargaArchivo/hechos_escenciales.pdf', isExternal: true, type: 'pdf' }
      ]
    },
    {
      title: 'Juntas de Accionistas',
      links: [
        { text: 'Junta ordinario de accionasitas', url: 'https://unipay.cl/api/descargaArchivo/Acta-JOA-Unicard%202024.pdf', isExternal: true, type: 'pdf' },
      ]
    },
    {
      title: 'Políticas',
      links: [
        { text: 'Términos y Condiciones', url: '/terminosycondiciones' },
        { text: 'Código de Conducta', url: 'https://www.unipay.cl/api/descargaArchivo/codigoconducta.PDF', isExternal: true, type: 'pdf' },
        { text: 'Política de Habitualidad', url: 'https://www.unipay.cl/api/descargaArchivo/politica_habitualidad_unicard.pdf', isExternal: true, type: 'pdf' },
        { text: 'Prevención de Delitos', url: 'https://www.unipay.cl/api/descargaArchivo/prevencion-de-delitos.pdf', isExternal: true, type: 'pdf' },
        ]
    },

  ];
}
